// src/components/RequireSubscription.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SubscriptionLocked from './SubscriptionLocked';

const RequireSubscription = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="flex justify-center items-center h-screen">Loading...</div>;
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Super Admins bypass subscription checks (if they are global admins)
    // But here 'user.role' is 'admin' for Org Admin. 
    // We check user.subscriptionStatus.

    // custom1: SUBSCRIPTION_BYPASS — skip gate entirely, always allow access
    // const allowedStatuses = ['active', 'trial', 'lifetime'];
    // const status = user.subscriptionStatus || 'trial';
    // if (!allowedStatuses.includes(status)) {
    //     return <SubscriptionLocked currentStatus={status} />;
    // }

    return children;
};

export default RequireSubscription;
